var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBiglogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Favicon_Copy",
    "data-name": "Favicon Copy",
    xmlns: "http://www.w3.org/2000/svg",
    width: 149,
    height: 171,
    viewBox: "0 0 149 171",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Star"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Star-2",
    "data-name": "Star",
    d: "M0,68.64l146.136-31.78L171,0,155.243,68.64Z",
    transform: "translate(0 171) rotate(-90)",
    fill: "rgba(0,0,0,0.85)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Star-3",
    "data-name": "Star",
    d: "M0,68.64l146.136-31.78L171,0,155.243,68.64Z",
    transform: "translate(0 171) rotate(-90)",
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Star-4",
    "data-name": "Star"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Star-5",
    "data-name": "Star",
    d: "M0,68.64l-146.136-31.78L-171,0l15.757,68.64Z",
    transform: "translate(149 171) rotate(90)",
    fill: "rgba(0,0,0,0.85)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Star-6",
    "data-name": "Star",
    d: "M0,68.64l-146.136-31.78L-171,0l15.757,68.64Z",
    transform: "translate(149 171) rotate(90)",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiglogo);
export default __webpack_public_path__ + "static/media/biglogo.62958d6b810bfa686a1651517aa27dfd.svg";
export { ForwardRef as ReactComponent };